import { render } from "./SupportDetail.vue?vue&type=template&id=51742a2e&scoped=true"
import script from "./SupportDetail.vue?vue&type=script&lang=js"
export * from "./SupportDetail.vue?vue&type=script&lang=js"

import "./SupportDetail.vue?vue&type=style&index=0&id=51742a2e&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51742a2e"]])

export default __exports__